module.exports = __webpack_public_path__ + "img/sx_6.9ae77834.png";